<template>
  <div class="card-container">
    <a-row>
      <a-col :span="12">
        <a-menu v-model="current"
                :default-selected-keys="['ticket']"
                mode="horizontal">
          <a-menu-item key="ticket">
            <a :href="'/train-admin/channelShop/policy-ticket?distributorId='+globalDistributorId"
               rel="noopener noreferrer">飞机票</a>
          </a-menu-item>
          <a-menu-item key="train">
            <a :href="'/train-admin/channelShop/policy-train?distributorId='+globalDistributorId"
               rel="noopener noreferrer">火车票</a>
          </a-menu-item>
          <a-menu-item key="hotel">
            <a :href="'/train-admin/channelShop/policy-hotel?distributorId='+globalDistributorId"
               rel="noopener noreferrer">酒店</a>
          </a-menu-item>
        </a-menu>
      </a-col>
      <a-col :span="12">
        <span style="float: right;margin-top:8px;">
          <a-button type="primary" @click="showLevelModal">选择职级</a-button>
        </span>
      </a-col>
    </a-row>

  </div>
  <a-tabs :animated="false" default-active-key="1">
    <a-tab-pane key="1" tab="基础配置">

      <a-form :model="policyForm" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="超标管控:">
          <a-radio-group v-model:value="policyForm.control">
            <a-radio value="deny">
              允许
            </a-radio>
            <a-radio value="allow">
              不允许
            </a-radio>
            <a-radio value="warn">
              仅提醒
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="超标处理:">
          <a-radio-group v-model:value="policyForm.disposal">
            <a-radio value="approval">
              审批
            </a-radio>
            <a-radio value="payment">
              自付
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="超标原因:">
          <a-radio-group v-model:value="policyForm.reasonRequired">
            <a-radio value="Y">
              必填
            </a-radio>
            <a-radio value="N">
              非必填
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="公告内容" name="notice">
          <a-textarea v-model:value="policyForm.notice"/>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button type="primary" @click="onSubmit">
            保存修改
          </a-button>
        </a-form-item>
      </a-form>

    </a-tab-pane>
    <a-tab-pane key="2" tab="标准配置">
      <a-row type="flex" justify="center">
        <a-col :span="4">
          职级
        </a-col>
        <a-col :span="4">
          仓等
        </a-col>
        <a-col :span="12">
          管控标准
        </a-col>
        <a-col :span="4">
          操作
        </a-col>
      </a-row>
      <a-row v-for="(ticketRoot,rootIndex) in ticketTicketData" type="flex" justify="center">
        <a-col :span="4">
          {{ ticketRoot.levelName }}
        </a-col>
        <a-col :span="4">
          <a-tag v-for="(item,index) in ticketRoot.cabinGradeInfo" :key="index"> {{ item.cabinGradeName }}</a-tag>
        </a-col>
        <a-col :span="12">
          <div v-for="(flightRuleGroup,flightRuleGroupIndex) in ticketRoot.policyTicketRuleList" :key="flightRuleGroupIndex">
            <a-row style="margin-bottom: 10px">
              <a-col :span="20">
                <span v-show="false">{{ticketRoot}}</span>
                <a-button @click="openPolicyTicketRuleModal(flightRuleGroup,ticketRoot)" type="primary" size="small" style="margin-right: 10px;">
                  添加管控
                </a-button>
              </a-col>
              <a-col :span="4">

              </a-col>
            </a-row>
            <a-table v-if="flightRuleGroup.controlStandard" :pagination="false" :columns="ticketStandardColumns" :data-source="flightRuleGroup.controlStandard.ruleList">
              <template v-slot:type="{ text,record,index }">
                <a v-if="record.type === 'city'">城市</a>
                <a v-if="record.type === 'discount'">折扣</a>
              </template>
              <template v-slot:formula="{ text,record,index }">
                <a v-if="record.formula === '()'">包含</a>
                <a v-if="record.formula === '!()'">不包含</a>
                <a v-if="record.formula === '<='">小于等于</a>
                <a v-if="record.formula === '<'">小于</a>
              </template>
              <template v-slot:mileage="{ text,record,index }">
                <div v-if="record.area">
                  <a-tag v-for="(item,index) in record.area" :key="item.areaCode"> {{ item.city }}</a-tag>
                </div>
                <a v-if="record.discount">{{ record.discount }}</a>
              </template>
              <template v-slot:unconformity="{ text,record,index }">
                <a-radio-group v-model:value="record.unconformity" @change="editPolicyTicketRuleList(record,index,flightRuleGroupIndex,rootIndex)">
                  <a-radio value="deny">
                    不允许
                  </a-radio>
                  <a-radio value="warn">
                    仅提醒
                  </a-radio>
                </a-radio-group>
              </template>
              <template v-slot:manage="{ text,record,index }">
                <a @click="putPolicyTicketRuleList(record,index,flightRuleGroupIndex,rootIndex)">删除</a>
              </template>
            </a-table>
          </div>
        </a-col>
        <a-col :span="4">
          <span v-show="false">
            {{ ticketRoot.cabinGrade }}
          </span>
          <a-button type="danger" size="small" @click="deleteFlightRule(ticketRoot)" style="margin-right: 10px;">
            删除
          </a-button>
          <a-button type="primary" size="small" @click="editFlightRule(ticketRoot)">
            编辑
          </a-button>
        </a-col>
      </a-row>
    </a-tab-pane>
  </a-tabs>

  <a-modal v-model:visible="levelVisible" title="选择职级差标" @ok="selectTicketRuleLevel">
    <a-form :model="policyTicketRuleForm" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="职级">
        <a-radio-group v-model:value="policyTicketRuleForm.levelId">
          <a-radio :disabled="policyTicketRuleFormState === true" :value="item.levelNo" v-for="(item,index) in distributorLevelList" :key="index">
            {{ item.levelName }}
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="舱等">
        <a-checkbox-group v-model:value="policyTicketRuleForm.cabinGrade">
          <a-checkbox :value="item.level" v-for="(item,index) in levelList" :key="index" name="level">
            {{ item.levelName }}
          </a-checkbox>
        </a-checkbox-group>
      </a-form-item>
    </a-form>
  </a-modal>

  <a-modal width="50%" v-model:visible="policyTicketRuleVisible" title="添加管控" @ok="addPolicyTicketRuleList">
    <a-form :model="policyTicketRuleInfoForm" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="管控类型">
        <a-select v-model:value="policyTicketRuleInfoForm.type" placeholder="选择管控类型">
          <a-select-option value="city">
            城市
          </a-select-option>
          <a-select-option value="discount">
            折扣
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="管控城市" v-if="policyTicketRuleInfoForm.type==='city'">

        <a-tabs type="card" @change="selectProvinceChildNode">
          <a-tab-pane v-for="(item,index) in provinceList" :key="item.areaCode" :tab="item.province">
          </a-tab-pane>
        </a-tabs>
        <a-select v-model:value="policyTicketRuleInfoForm.formula" placeholder="管控公式">
          <a-select-option value="()">
            包含
          </a-select-option>
          <a-select-option value="!()">
            不包含
          </a-select-option>
        </a-select>
        <a-checkbox-group v-model:value="policyTicketRuleInfoForm.city">
          <a-checkbox v-if="provinceChildNodeList.length > 0 && provinceChildNodeList[0].provinceLevel==='N'" v-for="(item,index) in provinceChildNodeList" :key="index" :value="item.areaCode" name="city">
            {{ item.city }}
          </a-checkbox>
          <a-checkbox  v-else  :value="provinceChildNodeList[0].areaCode" name="city">
            {{ provinceChildNodeList[0].city }}
          </a-checkbox>
        </a-checkbox-group>
      </a-form-item>
      <a-form-item label="折扣" v-if="policyTicketRuleInfoForm.type==='discount'">
        <a-select v-model:value="policyTicketRuleInfoForm.formula" placeholder="管控公式">
          <a-select-option value="<=">
            小于等于
          </a-select-option>
          <a-select-option value="<">
            小于
          </a-select-option>
        </a-select>
        <a-input v-model:value="policyTicketRuleInfoForm.discount"/>
      </a-form-item>
      <a-form-item label="不符合时">
        <a-radio-group name="unconformity" v-model:value="policyTicketRuleInfoForm.unconformity">
          <a-radio value="deny">
            不允许
          </a-radio>
          <a-radio value="warn">
            仅提醒
          </a-radio>
        </a-radio-group>
      </a-form-item>
    </a-form>
  </a-modal>


</template>

<script>
import {SmileOutlined, DownOutlined} from '@ant-design/icons-vue';
import {ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import policy from "@axios/policy";
import {notification} from 'ant-design-vue';

export default {
  components: {
    SmileOutlined,
    DownOutlined,
  },
  name: "index",
  setup() {
    const router = useRouter()
    const route = useRoute()
    const business = 40
    const globalDistributorId = route.query.distributorId

    /** 城市List **/
    let provinceList = ref([])
    const findPolicyProvince = () => {
      const query = {
        parentId: 0
      }
      policy.getPolicyCity(query).then(p => {
        provinceList.value = p
        if(  p.length > 0 ){
          selectProvinceChildNode(p[0].areaCode)
        }
      })
    }

    /** 子节点城市 **/
    let provinceChildNodeList = ref([])
    const selectProvinceChildNode = (areaCode) => {
      console.log(areaCode)
      policy.getCityChildNode(areaCode).then(c => {
        provinceChildNodeList.value = c
      })
    }


    let policyForm = ref({
      id: null,
      control: null,
      disposal: null,
      reasonRequired: null,
      distributorId: globalDistributorId,
      business: business,
      notice: null
    })


    const findPolicy = () => {
      const _policyForm = {
        control: policyForm.value.control,
        disposal: policyForm.value.disposal,
        reasonRequired: policyForm.value.reasonRequired,
        distributorId: policyForm.value.distributorId,
        business: policyForm.value.business,
      }
      console.log(_policyForm)
      policy.getPolicy(_policyForm).then(p => {
        policyForm.value = {
          distributorId: p.distributorId,
          control: p.control,
          disposal: p.disposal,
          reasonRequired: p.reasonRequired,
          business: business,
          id: p.id,
          notice: p.notice
        }
        console.log(policyForm)
      })
    }
    findPolicy()

    const onSubmit = () => {
      console.log('submit!', policyForm);
      const _policyForm = policyForm.value
      policy.addAndEditPolicy(_policyForm).then(p => {
        console.log(p)
        openNotification('success', '修改成功.')
      })
    }

    const openNotification = (type, description) => {
      notification[type]({
        message: '提示',
        description: description
      })
    }

    /** 获取机票差标信息 **/
    let ticketTicketData = ref([])
    const getPolicyTicketRule = () => {
      const query = {
        distributorId: globalDistributorId,
        business: 40
      }
      policy.getPolicyTicketRule(query).then(pt => {
        ticketTicketData.value = pt
      })
    }
    getPolicyTicketRule()


    const ticketColumns = [
      {
        dataIndex: 'levelName',
        title: '职级',
        key: 'levelName',
        width: 150,
        align: 'center',
        slots: {customRender: 'levelName'},
      },
      {
        title: '仓等',
        dataIndex: 'cabinGradeInfo',
        width: 200,
        align: 'center',
        key: 'cabinGradeInfo',
        slots: {customRender: 'cabinGradeInfo'},
      },
      {
        title: '管控标准',
        dataIndex: 'flightRuleGroupList',
        key: 'flightRuleGroupList',
        slots: {customRender: 'flightRuleGroupList'},
      },
      {
        title: '操作',
        key: 'operate',
        width: 200,
        align: 'center',
        dataIndex: 'operate',
        slots: {customRender: 'operate'},
      }
    ]

    let standardColumnsData = ref([])
    const standardColumns = [
      {
        dataIndex: 'type',
        title: '管控类型',
        key: 'type',
        width: 150,
        align: 'center',
        slots: {customRender: 'type'},
      },
      {
        title: '管控条件',
        dataIndex: 'formula',
        width: 200,
        align: 'center',
        key: 'formula',
        slots: {customRender: 'formula'},
      },
      {
        title: '条件规则',
        dataIndex: 'mileage',
        key: 'mileage',
        slots: {customRender: 'mileage'},
      },
      {
        title: '不符合时',
        key: 'unconformity',
        width: 200,
        align: 'center',
        dataIndex: 'unconformity',
        slots: {customRender: 'unconformity'},
      },
      {
        title: '-',
        key: 'manage',
        width: 100,
        align: 'center',
        dataIndex: 'manage',
        slots: {customRender: 'manage'},
      }
    ]
    /*******/
    let levelVisible = ref(false)

    const defaultPolicyTicketRuleForm = ref({
      levelId: null,
      cabinGrade: [],
      layout: "vertical",
      id: null
    })
    let policyTicketRuleForm = ref({
      levelId: null,
      cabinGrade: [],
      layout: "vertical",
      id: null
    })
    let distributorLevelList = ref([])

    const showLevelModal = () => {
      policyTicketRuleForm.value = defaultPolicyTicketRuleForm.value
      policyTicketRuleFormState.value = false
      levelVisible.value = true
      let query = {
        distributorId: policyForm.value.distributorId
      }
      policy.getLevelList(query).then(l => {
        distributorLevelList.value = l
      })
    }

    const selectTicketRuleLevel = (e) => {
      if (policyTicketRuleForm.value.cabinGrade.length < 1) {
        return
      }
      const cabinGrade = policyTicketRuleForm.value.cabinGrade.join(",")
      const ticketRule = {
        policyBaseId: policyForm.value.id,
        distributorId: globalDistributorId,
        levelId: policyTicketRuleForm.value.levelId,
        cabinGrade: cabinGrade
      }
      console.log(ticketRule)
      policy.addPolicyTicketRule(ticketRule).then(p => {
        console.log(p)
        getPolicyTicketRule()
      })
      levelVisible.value = false
    }

    const levelList = [
      {level: "Y", levelName: "经济舱"},
      {level: "F", levelName: "头等舱"},
      {level: "C", levelName: "商务舱"}
    ]

    const deleteFlightRule = (record) => {
      const deleteParams = {
        policyBaseId: policyForm.value.id,
        distributorId: globalDistributorId,
        id: record.id,
      }
      console.log(deleteParams)
      policy.deletePolicyTicketRule(deleteParams).then(d => {
        console.log(d)
        getPolicyTicketRule()
      })
    }

    const putPolicyTicketRuleList = (record, index, flightRuleGroupIndex, rootIndex) => {
      console.log(record, '-', index, '-', flightRuleGroupIndex, '-', rootIndex)
      ticketTicketData.value[rootIndex].policyTicketRuleList[flightRuleGroupIndex].controlStandard.ruleList.splice(index, 1)
      const _ticketTicketData = ticketTicketData.value[rootIndex].policyTicketRuleList[flightRuleGroupIndex]
      const policyTicketRuleList = {
        policyTicketRuleId: _ticketTicketData.policyTicketRuleId,
        id: _ticketTicketData.id,
        controlStandardObject: _ticketTicketData.controlStandard
      }
      policy.putPolicyTicketRuleList(policyTicketRuleList).then(p => {
        console.log(p)
      })
    }

    const editPolicyTicketRuleList = (record, index, flightRuleGroupIndex, rootIndex) => {
      const _ticketTicketData = ticketTicketData.value[rootIndex].policyTicketRuleList[flightRuleGroupIndex]
      const policyTicketRuleList = {
        policyTicketRuleId: _ticketTicketData.policyTicketRuleId,
        id: _ticketTicketData.id,
        controlStandardObject: _ticketTicketData.controlStandard
      }
      policy.putPolicyTicketRuleList(policyTicketRuleList).then(p => {
        console.log(p)
      })
    }


    /** 机票添加模块 **/
    const defaultPolicyTicketRuleInfoForm = ref({
      type: null,
      city: [],
      discount: null,
      formula: null,
      unconformity: 'deny',
      id: null,
      policyTicketRuleId: null
    })

    const policyTicketRuleVisible = ref(false)
    let policyTicketRuleInfoForm = ref({
      type: null,
      city: [],
      discount: null,
      formula: null,
      unconformity: 'deny',
      id: null,
      policyTicketRuleId: null
    })

    const openPolicyTicketRuleModal = (flightRuleGroup, ticketRoot) => {
      console.log(flightRuleGroup)
      findPolicyProvince()
      policyTicketRuleVisible.value = true
      if (ticketRoot.id) {
        policyTicketRuleInfoForm.value.policyTicketRuleId = ticketRoot.id
        policyTicketRuleInfoForm.value.id = flightRuleGroup.id
      }
    }
    const addPolicyTicketRuleList = () => {
      if (!policyTicketRuleInfoForm.value.policyTicketRuleId) {
        return
      }
      policyTicketRuleVisible.value = false
      let params = {
        policyTicketRuleId: policyTicketRuleInfoForm.value.policyTicketRuleId,
        id: policyTicketRuleInfoForm.value.id,
        controlStandardObject: {
          rule: 'all',
          conditions: true,
          ruleList: [{
            type: policyTicketRuleInfoForm.value.type,
            formula: policyTicketRuleInfoForm.value.formula,
            discount: policyTicketRuleInfoForm.value.discount,
            city: policyTicketRuleInfoForm.value.city,
            unconformity: policyTicketRuleInfoForm.value.unconformity
          }]
        }
      }
      policy.addPolicyTicketRuleList(params).then(ticketRuleList => {
        getPolicyTicketRule()
        params = {}
        policyTicketRuleInfoForm.value = defaultPolicyTicketRuleInfoForm.value
        policyTicketRuleInfoForm.value.id = ticketRuleList.id
        policyTicketRuleInfoForm.value.policyTicketRuleId = ticketRuleList.policyTicketRuleId
      })
    }

    /** 编辑配置管理 **/
    let policyTicketRuleFormState = ref(false)
    const editFlightRule = (ticketRoot) => {
      policyTicketRuleFormState.value = true
      policyTicketRuleForm.value = {
        levelId: ticketRoot.levelId,
        cabinGrade: ticketRoot.cabinGrade.split(","),
        layout: "vertical",
        id: ticketRoot.id
      }

      levelVisible.value = true
      let query = {
        distributorId: policyForm.value.distributorId
      }
      policy.getLevelList(query).then(l => {
        distributorLevelList.value = l
      })
    }

    return {
      policyTicketRuleFormState,
      provinceChildNodeList,
      selectProvinceChildNode,
      provinceList,
      globalDistributorId,
      editFlightRule,
      defaultPolicyTicketRuleInfoForm,
      addPolicyTicketRuleList,
      policyTicketRuleVisible,
      openPolicyTicketRuleModal,
      policyTicketRuleInfoForm,

      editPolicyTicketRuleList,
      putPolicyTicketRuleList,
      deleteFlightRule,
      getPolicyTicketRule,
      findPolicy,
      labelCol: {span: 4},
      wrapperCol: {span: 18},
      levelList,
      distributorLevelList,
      showLevelModal,
      levelVisible: levelVisible,
      policyTicketRuleForm: policyTicketRuleForm,
      selectTicketRuleLevel,
      policyForm,
      business,
      onSubmit,
      openNotification,
      ticketTicketData: ticketTicketData,
      ticketColumns: ticketColumns,
      ticketStandardColumnsData: standardColumnsData,
      ticketStandardColumns: standardColumns,
      current: ['ticket']
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.ant-tabs-nav-scroll {
  background-color: #F3F3F3;
}

.ant-col-offset-4 {
  margin-left: 100px;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>

.ant-menu-item-active {
  background-color: #F3F3F3;
}

.card-container {
  overflow: hidden;
  padding: 0px;
}

.ant-menu-item-selected {
  background-color: #F3F3F3;
  border-bottom: none;
  width: 100px;
}

.ant-menu-item-selected a, .ant-menu-item > a {
  text-align: center;
  font-size: 16px;
}

.ant-menu-item:hover {
  border-bottom: none;
  background-color: #F3F3F3;
}

.ant-menu-item {
  width: 100px;
}

.ant-tabs-nav-wrap, .ant-tabs-nav-scroll {
  background-color: #F3F3F3;
  height: 80px;
}

.ant-tabs-tab-active {
  background-color: #F3F3F3;
}

.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
  margin: 0;
  text-align: center;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #fff;
  background: #fff;
}

.ant-select {
  padding-bottom: 5px;
}
.ant-checkbox-wrapper {
  margin-left: 0;
}
</style>
